export default "__VITE_ASSET__DnT9rNbw__"